module.exports = __webpack_public_path__ + "static/media/amn-brains-w.b8fdfb80.png";